"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformNumberingTemplateToString = void 0;
function transformNumberingTemplateToString(numberingTemplate, invoiceNumber) {
    return (`${numberingTemplate.prefix}${new Date().getFullYear()}` +
        `${invoiceNumber
            ? invoiceNumber
                .toString()
                .padStart(numberingTemplate.digits, "0")
            : ""}`);
}
exports.transformNumberingTemplateToString = transformNumberingTemplateToString;
//# sourceMappingURL=transformNumberingTemplateToString.js.map